import React, { Dispatch, SetStateAction, useState } from 'react';
import { Input } from '@/components/shadcn/input';
import { FilterTypes, FiltersState } from '@/types/scout';
import SearchIcon from '@/components/ui/icons/SearchIcon';

export interface FiltersProps {
  filters: FiltersState;
  setFilters: Dispatch<SetStateAction<FiltersState>>;
}

const Filters: React.FC<FiltersProps> = ({ filters, setFilters }) => {
  const [value, setValue] = useState(filters.search);

  const onChange = (key: keyof FiltersState, value: string | string[]) => {
    setFilters(filters => ({
      ...filters,
      [key]: value,
    }));
  };

  return (
    <div className="flex justify-start gap-4">
      <div className="flex w-1/2 md:w-auto">
        <div className="relative flex w-full items-center gap-2 rounded border border-neutral-700 bg-neutral-900 px-4 text-neutral-0 md:w-auto md:min-w-60">
          <SearchIcon className="size-4 fill-current" />
          <Input
            value={value}
            placeholder={'Search all locations'}
            onChange={e => {
              const searchValue = e.target.value.toLowerCase();
              setValue(e.target.value);
              onChange(FilterTypes.SEARCH, searchValue);
            }}
            className="border-none p-0 leading-none placeholder:text-neutral-700"
          />
        </div>
      </div>
    </div>
  );
};

export default Filters;
